// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pl-1";
export var stateContainer = "_pl-0";